/* import __COLOCATED_TEMPLATE__ from './email-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();